import React, { useState, useEffect } from 'react';
import { FaPrint, FaShieldAlt, FaEdit, FaSave } from 'react-icons/fa';

const Sticker = ({ license }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [stickerData, setStickerData] = useState({
        customer_name: '',
        license_key: '',
        toll_free: '1800-XXX-XXXX',
        direct_no: '',
        direct_number: '',
        account_manager: ''
    });

    useEffect(() => {
        if (license) {
            setStickerData({
                customer_name: license.customer_name || '',
                license_key: license.license_key || '',
                toll_free: '1800-XXX-XXXX',
                direct_no: '',
                direct_number: '',
                account_manager: license.account_manager || 'Not Assigned'
            });
        }
    }, [license]);

    if (!license) return null;

    const handlePrint = () => {
        window.print();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStickerData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div className="sticker-container">
            <div id="license-sticker" className="sticker-card">
                <div className="sticker-header">
                    <FaShieldAlt className="sticker-icon" />
                    <h2>GUARDIAN</h2>
                </div>

                <div className="sticker-body">
                    <div className="sticker-field">
                        <label>CUSTOMER NAME</label>
                        {isEditing ? (
                            <input name="customer_name" value={stickerData.customer_name} onChange={handleChange} className="sticker-input" />
                        ) : (
                            <p>{stickerData.customer_name}</p>
                        )}
                    </div>

                    <div className="sticker-field">
                        <label>BE NUMBER</label>
                        {isEditing ? (
                            <input name="license_key" value={stickerData.license_key} onChange={handleChange} className="sticker-input be-number" />
                        ) : (
                            <p className="be-number">{stickerData.license_key}</p>
                        )}
                    </div>

                    <div className="sticker-row">
                        <div className="sticker-field">
                            <label>TOLL FREE</label>
                            {isEditing ? (
                                <input name="toll_free" value={stickerData.toll_free} onChange={handleChange} className="sticker-input" />
                            ) : (
                                <p>{stickerData.toll_free}</p>
                            )}
                        </div>
                        <div className="sticker-field">
                            <label>ACCOUNT MANAGER</label>
                            {isEditing ? (
                                <input name="account_manager" value={stickerData.account_manager} onChange={handleChange} className="sticker-input" />
                            ) : (
                                <p>{stickerData.account_manager}</p>
                            )}
                        </div>
                    </div>

                    <div className="sticker-row">
                        <div className="sticker-field">
                            <label>DIRECT NO</label>
                            {isEditing ? (
                                <input name="direct_no" value={stickerData.direct_no} onChange={handleChange} className="sticker-input" />
                            ) : (
                                <p>{stickerData.direct_no || '-'}</p>
                            )}
                        </div>
                        <div className="sticker-field">
                            <label>DIRECT NUMBER</label>
                            {isEditing ? (
                                <input name="direct_number" value={stickerData.direct_number} onChange={handleChange} className="sticker-input" />
                            ) : (
                                <p>{stickerData.direct_number || '-'}</p>
                            )}
                        </div>
                    </div>
                </div>

                <div className="sticker-footer">
                    {/* <p>Official Security License - iTECH 365</p> */}
                </div>
            </div>

            <div className="sticker-actions no-print" style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'center' }}>
                <button onClick={() => setIsEditing(!isEditing)} className="edit-btn" style={{ background: isEditing ? '#45a29e' : '#1f2833' }}>
                    {isEditing ? <><FaSave /> Save View</> : <><FaEdit /> Edit Fields</>}
                </button>
                <button onClick={handlePrint} className="print-btn" disabled={isEditing}><FaPrint /> Print Sticker</button>
            </div>

            <style>{`
                .sticker-card {
                    width: 450px;
                    background: #fff;
                    color: #000;
                    padding: 25px;
                    border: 3px solid #000;
                    border-radius: 12px;
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                    box-shadow: 0 4px 15px rgba(0,0,0,0.5);
                    margin: 0 auto;
                }
                .sticker-header {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 12px;
                    border-bottom: 4px solid #000;
                    margin-bottom: 25px;
                    padding-bottom: 12px;
                }
                .sticker-header h2 {
                    margin: 0;
                    font-size: 2.2rem;
                    font-weight: 900;
                    letter-spacing: 3px;
                }
                .sticker-icon {
                    font-size: 2.8rem;
                }
                .sticker-field {
                    margin-bottom: 18px;
                }
                .sticker-field label {
                    display: block;
                    font-size: 0.75rem;
                    font-weight: 800;
                    color: #444;
                    margin-bottom: 4px;
                    text-transform: uppercase;
                }
                .sticker-field p {
                    margin: 0;
                    font-size: 1.25rem;
                    font-weight: 700;
                    text-transform: uppercase;
                    min-height: 1.5rem;
                }
                .sticker-input {
                    width: 100%;
                    padding: 5px;
                    font-size: 1.1rem;
                    font-weight: 700;
                    border: 1px dashed #aaa;
                    background: #f9f9f9;
                    color: #000;
                    text-transform: uppercase;
                }
                .be-number {
                    color: #d32f2f;
                    font-size: 1.6rem !important;
                    letter-spacing: 1.5px;
                }
                .sticker-row {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 20px;
                }
                .sticker-footer {
                    margin-top: 25px;
                    border-top: 2px solid #000;
                    padding-top: 12px;
                    text-align: center;
                    font-size: 0.7rem;
                    font-weight: bold;
                    color: #333;
                }
                .sticker-actions button {
                    padding: 10px 20px;
                    border-radius: 5px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-weight: bold;
                }
                .print-btn { background: #66fcf1; color: #0b0c10; border: none; }
                .edit-btn { background: #1f2833; color: #66fcf1; border: 1px solid #45a29e; }
                
                @media print {
                    .no-print { display: none !important; }
                    body * { visibility: hidden; }
                    #license-sticker, #license-sticker * { visibility: visible; }
                    #license-sticker {
                        position: absolute;
                        left: 50%;
                        top: 20px;
                        transform: translateX(-50%);
                        margin: 0;
                        box-shadow: none;
                        border: 3px solid #000;
                    }
                    .sticker-input {
                        border: none !important;
                        background: transparent !important;
                        padding: 0 !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default Sticker;

